/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BareLogPreviewItemDto
 */
export interface BareLogPreviewItemDto {
    /**
     * 
     * @type {string}
     * @memberof BareLogPreviewItemDto
     */
    logId: string;
    /**
     * Golden-record messageType; "unknown" when missing
     * @type {string}
     * @memberof BareLogPreviewItemDto
     */
    messageType: string;
    /**
     * 
     * @type {Date}
     * @memberof BareLogPreviewItemDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof BareLogPreviewItemDto
     */
    receivedAt: Date | null;
    /**
     * Original payload from metadata.rawMessage
     * @type {object}
     * @memberof BareLogPreviewItemDto
     */
    rawMessage: object;
}

/**
 * Check if a given object implements the BareLogPreviewItemDto interface.
 */
export function instanceOfBareLogPreviewItemDto(value: object): value is BareLogPreviewItemDto {
    if (!('logId' in value) || value['logId'] === undefined) return false;
    if (!('messageType' in value) || value['messageType'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('receivedAt' in value) || value['receivedAt'] === undefined) return false;
    if (!('rawMessage' in value) || value['rawMessage'] === undefined) return false;
    return true;
}

export function BareLogPreviewItemDtoFromJSON(json: any): BareLogPreviewItemDto {
    return BareLogPreviewItemDtoFromJSONTyped(json, false);
}

export function BareLogPreviewItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BareLogPreviewItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'logId': json['logId'],
        'messageType': json['messageType'],
        'createdAt': (new Date(json['createdAt'])),
        'receivedAt': (json['receivedAt'] == null ? null : new Date(json['receivedAt'])),
        'rawMessage': json['rawMessage'],
    };
}

export function BareLogPreviewItemDtoToJSON(json: any): BareLogPreviewItemDto {
    return BareLogPreviewItemDtoToJSONTyped(json, false);
}

export function BareLogPreviewItemDtoToJSONTyped(value?: BareLogPreviewItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'logId': value['logId'],
        'messageType': value['messageType'],
        'createdAt': value['createdAt'].toISOString(),
        'receivedAt': value['receivedAt'] == null ? value['receivedAt'] : value['receivedAt'].toISOString(),
        'rawMessage': value['rawMessage'],
    };
}

